export interface ValidationProblemDetails {
  title?: string;
  status?: number;
  errors?: Record<string, string[]>;
}

export interface FieldErrorMap {
  [key: string]: string;
}

export function getFieldValidationErrors(
  error: unknown,
  fieldMap: FieldErrorMap
): Record<string, string> {
  const axiosError = error as { response?: { data?: any } } | undefined;

  if (!axiosError?.response?.data) return {};

  const data = axiosError.response.data;

  if (typeof data !== "object" || data === null) return {};

  const problemDetails = data as ValidationProblemDetails;

  if (!problemDetails.errors || typeof problemDetails.errors !== "object") return {};

  const messageMap: Record<string, string> = {};

  for (const [key, messages] of Object.entries(problemDetails.errors)) {
    if (Array.isArray(messages) && messages.length > 0) {
      messageMap[key] = messages[0];
    } else if (typeof messages === "string") {
      messageMap[key] = messages;
    }
  }

  const result: Record<string, string> = {};

  for (const [pascalKey, fieldName] of Object.entries(fieldMap)) {
    const msgKey = pascalKey.toLowerCase();
    if (msgKey in messageMap) {
      result[fieldName] = messageMap[msgKey];
    }
  }

  return result;
}